@if (upgradePrompt.open()) {
  <div
    class="ju-backdrop"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'nav.upgrade.title' | transloco"
    (click)="upgradePrompt.close()"
  >
    <section class="ju-card" (click)="$event.stopPropagation()">
      <button type="button" class="ju-close" [attr.aria-label]="'nav.upgrade.reject' | transloco" (click)="upgradePrompt.close()">
        <lucide-icon [img]="closeIcon" [size]="18" aria-hidden="true" />
      </button>

      <div class="ju-head">
        <h2 class="ju-headline">
          @if (upgradePrompt.featureName(); as feature) {
            @let parts = headlineParts(feature);
            {{ parts.before }}<span class="ju-feature">{{ feature }}</span>{{ parts.after }}
          } @else {
            {{ 'nav.upgrade.headline' | transloco }}
          }
        </h2>
        <p class="ju-tagline">{{ 'nav.upgrade.tagline' | transloco }}</p>
      </div>

      <div class="ju-plans">
        @for (plan of visiblePlans(); track plan.key) {
          <article class="ju-plan" [class.ju-plan--popular]="plan.popular">
            @if (plan.popular) {
              <span class="ju-plan__badge">{{ 'nav.upgrade.plans.popular' | transloco }}</span>
            }

            <h3 class="ju-plan__name">{{ plan.nameKey | transloco }}</h3>

            <div class="ju-plan__price">
              <span class="ju-plan__amount">{{ plan.priceKey | transloco }}</span>
              <span class="ju-plan__meta">
                <span class="ju-plan__period">{{ 'nav.upgrade.plans.period' | transloco }}</span>
                <span class="ju-plan__fees">{{ 'nav.upgrade.plans.fees' | transloco }}</span>
              </span>
            </div>

            <p class="ju-plan__desc">{{ plan.descKey | transloco }}</p>

            <button type="button" class="ju-plan__cta" (click)="upgradePrompt.openPortal()">
              {{ 'nav.upgrade.plans.cta' | transloco }}
            </button>

            <span class="ju-plan__features-label">{{ 'nav.upgrade.plans.featuresLabel' | transloco }}</span>
            <ul class="ju-plan__features">
              @for (featureKey of plan.featureKeys; track featureKey) {
                <li class="ju-plan__feature">
                  <span class="ju-plan__check" aria-hidden="true">
                    <lucide-icon [img]="checkIcon" [size]="12" [strokeWidth]="3" />
                  </span>
                  {{ featureKey | transloco }}
                </li>
              }
            </ul>

            <p class="ju-plan__footnote">{{ 'nav.upgrade.plans.footnote' | transloco }}</p>
          </article>
        }
      </div>

      <button type="button" class="ju-meeting" (click)="upgradePrompt.openMeeting()">
        <lucide-icon [img]="meetingIcon" [size]="16" [strokeWidth]="2" aria-hidden="true" />
        {{ 'nav.upgrade.plans.notSure' | transloco }}
      </button>
    </section>
  </div>
}
